import {createAction} from 'web-app/util/redux/typed-action-helpers';

const domain = 'MODALS/ACH_INSTANT_VERIFICATION_MODAL';

type ShowActionPayload = {isInternal?: false} | {isInternal: true; onSuccess?: () => void};

export const {action: show} = createAction(`${domain}/SHOW`, (payload?: ShowActionPayload): ShowActionPayload => {
    if (payload?.isInternal) {
        return {
            isInternal: true,
            onSuccess: payload.onSuccess,
        };
    }
    return {
        isInternal: false,
    };
});

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
